<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="formData"
            :model="formData"
            :rules="rules"
            label-width="180px"
            size="mini"
        >
            <div class="top">
                <div style="font-weight: 900;">下载模板</div>
                <div>
                    <a href="/export/SB种子词模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“SB种子词模板”模板</a>
                </div>
            </div>
            <el-form-item label="国家：" class="query-form-item" prop="state">
                <el-select
                    v-model="formData.state"
                    ref="carrerSelect"
                    style="width: 120px;"
                    size="mini"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                :icon-class="item.us"
                                style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                            >{{ item.title }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="店铺名称：" prop="shop_name">
                <el-select
                    v-model="formData.shop_name"
                    placeholder="请选择店铺名称"
                    ref="carrerSelect"
                    style="width: 300px;margin-right:20px;"
                    size="mini"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="item in list"
                        :key="item.id"
                        :label="item.shop_name"
                        :value="item.shop_name"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed="handExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <div
                        class="el-upload__text"
                        style="font-size: 12px;margin-top: 5px;"
                    >
                        只能上传.xls/.xlsx文件
                    </div>
                </el-upload>
            </div>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >取 消
            </el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
            >确定
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/Product/Product.js'

    export default {
        data() {
            return {
                list: [],
                formData: {},
                loading: false,
                files: [],
                date: '',
                rules: {
                    state: [
                        {
                            required: true,
                            message: '请输入国家',
                            trigger: 'blur'
                        }
                    ],
                    shop_name: [
                        {
                            required: true,
                            message: "请输入店铺名称",
                            trigger: "blur"
                        }
                    ],
                }
            }
        },
        props: {
            us_arr: {
                type: Array,
                default: () => []
            },
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            }
        },
        mounted() {
            this.getShopList()
        },
        methods: {
            getShopList(){
                api.shop_name_list().then(res => {
                    if (res.code === 0) {
                        this.list = res.data || []
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            },
            handleUpload(raw) {
                this.files.push(raw.file)
            },
            handExceed(files, fileList) {
                this.$message({
                    type: 'warning',
                    message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
                })
                return
            },
            handFileSuccess() {
                this.files = []
                this.$refs.upload.clearFiles()
            },
            handleRemove(file, fileList) {
                this.files = fileList
            },
            // 保存信息
            submitForm(formData) {
                this.$refs[formData].validate(valid => {
                    if (valid) {
                        this.$refs.upload.submit() // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                        if (this.files.length == 0) {
                            this.$message.warning(`当前限制只能上传选择 1 个文件`)
                            return
                        }
                        let file = new FormData()
                        file.append('file', this.files[0])
                        file.append("state", this.formData.state);
                        file.append("shop_name", this.formData.shop_name);

                        this.loading = true
                        api.upload_source_file(file)
                            .then(res => {
                                if (res.code === 0) {
                                    this.loading = false
                                    this.$message({
                                        type: 'success',
                                        message: '添加成功'
                                    })
                                    this.formData = {}
                                    this.handleClose(false)
                                } else {
                                    this.loading = false
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message:
                                        '网络出现问题，请查看数据是否添加完成！'
                                })
                            })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            // 关闭弹窗
            handleClose(isshow = true) {
                this.formData = {}
                this.handFileSuccess()
                this.$refs['formData'].resetFields()
                this.loading = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .download {
        display: flex;
        justify-content: center;
    }

    .top {
        margin: 0px auto;
        width: 60%;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
    }
</style>
